import { clsx } from 'clsx'
import { type FC } from 'react'

import { CartIntermediateAdBanner } from '../../CartIntermediateAdBanner/CartIntermediateAdBanner'
import { useCartIntermediateContext } from '../../hooks/useCartIntermediateContext'
import { CartIntermediateCtaButtons } from '../CartIntermediateCtaButtons/CartIntermediateCtaButtons'

import { CartIntermediateProductWithButtonsSectionContent } from './CartIntermediateProductWithButtonSectionContent'

import styles from './CartIntermediateProductWithButtonsSection.module.css'

type CartIntermediateProductWithButtonsSectionType = {
  handleClose: () => void
}
export const CartIntermediateProductWithButtonsSection: FC<
  CartIntermediateProductWithButtonsSectionType
> = ({ handleClose }) => {
  const { entries } = useCartIntermediateContext()
  const [, recommendedProduct] = entries ?? []
  const hasRecommendedProduct = Boolean(recommendedProduct)

  return (
    <div
      className={clsx(
        'flex flex-col gap-y-2 tablet:grid tablet:grid-cols-2 tablet:gap-x-4 tablet:gap-y-2',
        hasRecommendedProduct
          ? styles['container-recomendations']
          : styles['container-no-recomendations'],
      )}
    >
      <CartIntermediateProductWithButtonsSectionContent />

      <div className={styles.cta}>
        <CartIntermediateCtaButtons handleClose={handleClose} />
      </div>

      <div className={styles.banner}>
        <CartIntermediateAdBanner />
      </div>
    </div>
  )
}
